import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  forwardRef,
} from "@angular/core";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

@Component({
  selector: "ws-checkbox",
  templateUrl: "./ws-checkbox.component.html",
  styleUrls: ["./ws-checkbox.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WsCheckboxComponent),
      multi: true,
    },
  ],
})
export class WsCheckboxComponent implements ControlValueAccessor {
  @Input() checked: boolean = false;
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() permission?: string;

  @Output() change: EventEmitter<MatCheckboxChange> =
    new EventEmitter<MatCheckboxChange>();

  @ViewChild("checkBox") checkBox?: MatCheckbox;
  @ViewChild("leftContent", { read: ElementRef }) leftContent!: ElementRef;
  @ViewChild("rightContent", { read: ElementRef }) rightContent!: ElementRef;

  private onTouched = () => {};
  private onChange: (_: any) => void = () => {};

  clickHandler(event: MatCheckboxChange): void {
    this.checked = event.checked;

    // 1. Inform Angular form
    this.onChange(event.checked);

    // 2. Inform custom output
    this.change.emit(event);

    // 3. Mark control as touched
    this.onTouched();
  }

  clickDivHandler(event: MouseEvent): void {
    event.preventDefault();
    if (this.checkBox && !this.disabled) {
      this.checkBox.toggle();
      this.clickHandler({
        source: this.checkBox,
        checked: this.checkBox.checked,
      });
    }
  }

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
